import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	menuLinks: [],
	isLoaded: false,
	isError: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.FETCH_MENU_LINKS_LOADING:
				return;
			case types.FETCH_MENU_LINKS_SUCCESS:
				draft.isLoaded = true;
				draft.menuLinks = action.payload;
				return;
			case types.FETCH_MENU_LINKS_ERROR:
				draft.isLoaded = true;
				draft.isError = true;
				return;
			default:
				return state;
		}
	});
